import { defineMessages } from 'react-intl';

export default defineMessages({
  yes: { defaultMessage: 'Yes' },
  no: { defaultMessage: 'No' },
});
